import fetchAPI from '../utils/service';

function getSponsorRequest() {
  return {
    type: 'GET_SPONSOR_REQUEST',
  };
}
function getSponsorSuccess(payload) {
  return {
    type: 'GET_SPONSOR_SUCCESS',
    payload,
  };
}
function getSponsorFailure(payload) {
  return {
    type: 'GET_SPONSOR_FAILURE',
    payload,
  };
}

function getSponsor(params) {
  return async (dispatch) => {
    dispatch(getSponsorRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/sponsor',
        params,
      });
      if (res.status === 200) {
        dispatch(getSponsorSuccess(res.data));
      } else {
        dispatch(getSponsorFailure({ message: 'Get sponsor failed' }));
      }
    } catch (error) {
      dispatch(getSponsorFailure(error));
    }
  };
}

function createSponsorRequest() {
  return {
    type: 'CREATE_SPONSOR_REQUEST',
  };
}

function createSponsorSuccess(payload) {
  return {
    type: 'CREATE_SPONSOR_SUCCESS',
    payload,
  };
}
function createSponsorFailure(payload) {
  return {
    type: 'CREATE_SPONSOR_FAILURE',
    payload,
  };
}

function createSponsor({ sponsor, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(createSponsorRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/sponsor',
        data: sponsor,
        method: 'POST',
      });
      if (res.status === 201) {
        dispatch(createSponsorSuccess(res.data));
        response.success();
      } else {
        dispatch(createSponsorFailure({ message: 'Create sponsor failed' }));
        response.failure();
      }
    } catch (error) {
      dispatch(createSponsorFailure(error));
      response.failure();
    }
  };
}

function editSponsorRequest() {
  return {
    type: 'EDIT_SPONSOR_REQUEST',
  };
}

function editSponsorSuccess(payload) {
  return {
    type: 'EDIT_SPONSOR_SUCCESS',
    payload,
  };
}
function editSponsorFailure(payload) {
  return {
    type: 'EDIT_SPONSOR_FAILURE',
    payload,
  };
}

function editSponsor({ sponsor, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(editSponsorRequest());
    try {
      const res = await fetchAPI({
        endpoints: `/sponsor/${sponsor._id}`,
        data: sponsor,
        method: 'PATCH',
      });
      if (res.status === 200) {
        dispatch(editSponsorSuccess(res.data));
        response.success();
      } else {
        dispatch(editSponsorFailure({ message: 'Edit sponsor failed' }));
        response.failure();
      }
    } catch (error) {
      dispatch(editSponsorFailure(error));
      response.failure();
    }
  };
}

function deleteSponsorRequest() {
  return {
    type: 'DELETE_SPONSOR_REQUEST',
  };
}

function deleteSponsorSuccess(payload) {
  return {
    type: 'DELETE_SPONSOR_SUCCESS',
    payload,
  };
}
function deleteSponsorFailure(payload) {
  return {
    type: 'DELETE_SPONSOR_FAILURE',
    payload,
  };
}

function deleteSponsor({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(deleteSponsorRequest());
    try {
      const res = await fetchAPI({
        endpoints: `/sponsor/${_id}`,
        method: 'DELETE',
      });
      if (res.status === 200) {
        dispatch(deleteSponsorSuccess(res.data));
        response.success();
      } else {
        dispatch(deleteSponsorFailure({ message: 'Delete sponsor failed' }));
        response.failure();
      }
    } catch (error) {
      dispatch(deleteSponsorFailure(error));
      response.failure();
    }
  };
}

export {
  getSponsor,
  createSponsor,
  editSponsor,
  deleteSponsor,
};



// WEBPACK FOOTER //
// ./src/actions/sponsor.js